import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { APP_PERMISSIONS } from './permissions';
import { useUserContext } from '@/contexts/userContext';

type Props = { entity: any; user?: any; open: boolean; onClose: () => void };

const ViewAccessDialog = ({ entity, user, open, onClose }: Props) => {
  const { t } = useTranslation();
  const userContext = useUserContext();

  const { firstName, lastName, userEmail, userAccess = {} } = user || userContext.user;

  const permissionGroups: any = APP_PERMISSIONS[entity?.entityType] || {};

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('entity.administration.accessControl.viewAccessdialog.header')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid size={12}>{`${firstName || lastName ? `${lastName}, ${firstName}` : userEmail}`}</Grid>
          <Grid size={12}>
            <Divider />
          </Grid>
          <Grid container size={12}>
            {Object.keys(permissionGroups).map((group: string) => {
              return (
                <Grid key={group} size={12}>
                  <FormControl size="small" component="fieldset">
                    <FormLabel component="legend">
                      {t(`entity.administration.accessControl.permissions.groups.${group}`)}
                    </FormLabel>
                    <FormGroup aria-label="position" row>
                      {Object.values(permissionGroups[group]).map((p: any) => {
                        return (
                          <FormControlLabel
                            key={p.fqn}
                            value={p.fqn}
                            control={
                              <Checkbox
                                size="small"
                                checked={(userAccess.permissions || []).includes(p.fqn)}
                                disabled
                              />
                            }
                            label={t(`entity.administration.accessControl.permissions.${p.name}`)}
                          />
                        );
                      })}
                    </FormGroup>
                  </FormControl>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button size="small" variant="text" onClick={onClose} sx={{ textTransform: 'none', fontWeight: 600 }}>
          {t('common.buttons.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewAccessDialog;
